/**
 * @Author: Nemo
 * @Description: 动态表单组件导出文件
 * @Date: 2024-11-20
 * @FilePath: /rhcn-checkout-web/src/componentsV2/busi/dynamic-form/index.js
 */

import { getFieldConfig, createRowFields } from './filed-manager';
import FormField from './FormField.vue';
import FormRowFields from './FormRowFields.vue';
import DynamicForm from './index.vue';

// 导出组件
export { DynamicForm, FormField, FormRowFields };

// 导出工具方法
export { getFieldConfig, createRowFields };

export default DynamicForm;
